"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _i18n = _interopRequireDefault(require("../utils/i18n"));

var _react = _interopRequireWildcard(require("react"));

var _reactFinalForm = require("react-final-form");

var _ramda = require("ramda");

var _finalFormArrays = _interopRequireDefault(require("final-form-arrays"));

var _reactI18next = require("react-i18next");

var _classnames = _interopRequireDefault(require("classnames"));

var _translations = require("../constants/translations");

var _questions = require("../utils/questions");

var _attrs = require("../utils/attrs");

var _errors = require("../utils/errors");

var _CompanyDictionary = require("../context/CompanyDictionary");

var _FormContext = require("../context/FormContext");

var _Fields = _interopRequireDefault(require("./Fields"));

var _Spinner = _interopRequireDefault(require("./formComponents/Spinner"));

var _Captcha = _interopRequireDefault(require("./formComponents/Captcha"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var styles = {
  "formWrapper": "index__formWrapper",
  "formBtn": "index__formBtn",
  "formBtnCancel": "index__formBtnCancel",
  "formLink": "index__formLink",
  "withoutOpd": "index__withoutOpd",
  "formLabel": "index__formLabel",
  "formLabelRequired": "index__formLabelRequired",
  "formLabelOptional": "index__formLabelOptional",
  "formInput": "index__formInput",
  "formTextarea": "index__formTextarea",
  "formSection": "index__formSection",
  "formSectionRow": "index__formSectionRow",
  "formSectionBtn": "index__formSectionBtn",
  "error": "index__error",
  "compositeError": "index__compositeError",
  "fileInput": "index__fileInput",
  "fileControls": "index__fileControls",
  "formDateSelect": "index__formDateSelect",
  "formMoneySelect": "index__formMoneySelect",
  "amountField": "index__amountField",
  "currencyField": "index__currencyField",
  "imagePreview": "index__imagePreview",
  "dangerBtn": "index__dangerBtn",
  "dangerBtnDisabled": "index__dangerBtnDisabled",
  "fileList": "index__fileList",
  "fileItem": "index__fileItem",
  "downloadButton": "index__downloadButton",
  "downloadButtonDisabled": "index__downloadButtonDisabled",
  "fileButtonGroup": "index__fileButtonGroup",
  "timeIndicator": "index__timeIndicator",
  "modalButtonGroup": "index__modalButtonGroup"
};

var getInitialValues = function getInitialValues(initialValues, fields, captchaOptions) {
  var values = initialValues || {};
  (0, _ramda.forEach)(function (field) {
    if (field.type === 'boolean' && !values[field.field]) {
      values[field.field] = false;
    }
  }, fields || []);

  if ((0, _ramda.path)(['captchaToken'], captchaOptions) && (0, _ramda.includes)((0, _ramda.path)(['captchaType'], captchaOptions), ['math', 'symbols'])) {
    values = (0, _ramda.assocPath)(['_captcha', 'key'], captchaOptions.captchaToken, values);
  }

  return values;
};

var Form = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Form, _Component);

  var _super = _createSuper(Form);

  function Form(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Form);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "changeOptions", function (field, options) {
      _this.setState(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          options: _objectSpread(_objectSpread({}, state.options), {}, (0, _defineProperty2["default"])({}, field, options))
        });
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "changeFieldValidation", function (fieldName, validate) {
      _this.setState(function (state) {
        return {
          fieldsWithoutValidation: _objectSpread(_objectSpread({}, state.fieldsWithoutValidation), {}, (0, _defineProperty2["default"])({}, fieldName, validate))
        };
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "componentDidUpdate", function (prevProps) {
      var language = prevProps.language;
      var _this$props = _this.props,
          languageProps = _this$props.language,
          initialValues = _this$props.initialValues,
          serverErrors = _this$props.serverErrors,
          fields = _this$props.fields,
          captchaOptions = _this$props.captchaOptions;

      if (languageProps !== language) {
        _this.setState({
          language: languageProps
        }, function () {
          _i18n["default"].changeLanguage(_this.state.language);
        });
      }

      if (!(0, _ramda.equals)(getInitialValues(initialValues, fields, captchaOptions), getInitialValues(prevProps.initialValues, prevProps.fields, prevProps.captchaOptions))) {
        _this.setState({
          initialValues: getInitialValues(initialValues, fields, captchaOptions)
        });
      }

      if (serverErrors && !prevProps.serverErrors && _this.state.submitted) {
        _this.setState({
          submitted: false
        });
      }

      if (!prevProps.serverErrors && serverErrors) {
        _this.scrollToInvalidField();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangeQuestion", function (field) {
      return function (value, form) {
        var batch = form.batch,
            change = form.change,
            getState = form.getState;
        var fields = _this.props.fields;
        var fieldType = field.fieldType,
            name = field.field;
        var isLinked = (0, _questions.isLinkedQuestion)(field);
        var formValues = (0, _ramda.prop)('values', getState());

        if (isLinked && formValues[name] !== value) {
          var geoQuestions = (0, _questions.findChildGeoQuestionsNames)(fields, fieldType, formValues);
          !(0, _ramda.isEmpty)(geoQuestions) && batch(function () {
            return geoQuestions.forEach(function (fieldName) {
              change(fieldName, undefined);
            });
          });
        }
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "reset", function () {
      _this.formProps.reset();

      _this.setState({
        submitted: false,
        errors: {}
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onSubmit", function (values) {
      _this.setState({
        submitted: true
      });

      _this.props.onSubmit(values, _objectSpread(_objectSpread({}, _this.formProps), {}, {
        reset: _this.reset
      }));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangeSubmitFailed", function (_ref) {
      var submitFailed = _ref.submitFailed;

      if (submitFailed && _this.props.onSubmitFail) {
        _this.props.onSubmitFail();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "scrollToInvalidField", function () {
      var _this$props2 = _this.props,
          scrollContainerClassName = _this$props2.scrollContainerClassName,
          scrollContainer = _this$props2.scrollContainer;

      var invalidField = _this.container.querySelector('.jobot-form-invalid');

      var scrollContainerElement = scrollContainer || scrollContainerClassName ? document.querySelector(scrollContainerClassName) : null;

      if (invalidField) {
        var input = invalidField.querySelector('input');

        if (scrollContainerElement) {
          scrollContainerElement.scrollTo({
            top: invalidField.getBoundingClientRect().top + scrollContainerElement.scrollTop - scrollContainerElement.getBoundingClientRect().top - 15,
            behavior: 'smooth'
          });
        } else {
          window.scrollTo({
            top: invalidField.getBoundingClientRect().top + window.scrollY - 15,
            behavior: 'smooth'
          });
        }

        if (input) {
          input.focus({
            preventScroll: true
          });
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleSubmit", function (e, handleSubmit) {
      _this.scrollToInvalidField();

      handleSubmit(e);
    });

    var _language = (0, _ramda.head)((props.language || _translations.RU).split('-'));

    var pdaLanguage = props.pdaLanguage || _language || _translations.RU;
    _this.state = {
      language: _language,
      pdaLanguage: pdaLanguage,
      dictionaries: {},
      errors: {},
      initialValues: getInitialValues(props.initialValues, props.fields, props.captchaOptions),
      fieldsWithoutValidation: {},
      options: {},
      submitted: false
    };
    _this.dictionaryTypes = [];
    _this.formProps = null;

    _i18n["default"].changeLanguage(_language);

    if (props.translations) {
      _i18n["default"].addResources('ru', 'translation', (0, _ramda.pathOr)({}, ['ru', 'translation'], props.translations));

      _i18n["default"].addResources('en', 'translation', (0, _ramda.pathOr)({}, ['en', 'translation'], props.translations));

      _i18n["default"].addResources('ua', 'translation', (0, _ramda.pathOr)({}, ['ua', 'translation'], props.translations));
    }

    return _this;
  }

  (0, _createClass2["default"])(Form, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          language = _this$state.language,
          pdaLanguage = _this$state.pdaLanguage;
      var _this$props3 = this.props,
          fields = _this$props3.fields,
          company = _this$props3.company,
          opdSubmitDisabled = _this$props3.opdSubmitDisabled,
          formRender = _this$props3.formRender,
          t = _this$props3.t,
          externalDisabled = _this$props3.disabled,
          externalSubmitting = _this$props3.submitting,
          serverErrors = _this$props3.serverErrors,
          htmlAttrs = _this$props3.htmlAttrs,
          html = _this$props3.html,
          captcha = _this$props3.captcha,
          captchaOptions = _this$props3.captchaOptions,
          customValidation = _this$props3.customValidation,
          updateOpdValuesOn = _this$props3.updateOpdValuesOn;
      var contextValue = {
        options: this.state.options,
        changeOptions: this.changeOptions
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(styles.formWrapper, {
          'jobot-form-server-failed': !!serverErrors
        }),
        ref: function ref(node) {
          return _this2.container = node;
        }
      }, /*#__PURE__*/_react["default"].createElement(_CompanyDictionary.CompanyDictionaryContext.Provider, {
        value: contextValue
      }, /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Form, {
        onSubmit: this.onSubmit,
        mutators: _objectSpread({}, _finalFormArrays["default"]),
        keepDirtyOnReinitialize: false,
        subscription: {
          values: false,
          submitFailed: true,
          submitting: true
        },
        initialValues: this.state.initialValues,
        noValidate: true
      }, function (formProps) {
        var handleSubmit = formProps.handleSubmit,
            finalForm = formProps.form,
            submitFailed = formProps.submitFailed,
            submitting = formProps.submitting;
        var submitted = _this2.state.submitted || submitting || !!externalSubmitting;
        var disabled = submitted || !!externalDisabled;

        if (!_this2.formProps) {
          _this2.formProps = finalForm;
        }

        return /*#__PURE__*/_react["default"].createElement("form", {
          className: submitFailed ? 'jobot-form-submit-failed' : '',
          onSubmit: function onSubmit(e) {
            return _this2.handleSubmit(e, handleSubmit);
          },
          ref: _this2.props.formRef,
          noValidate: true
        }, /*#__PURE__*/_react["default"].createElement(_FormContext.FormContext.Provider, {
          value: {
            disabled: disabled,
            htmlAttrs: htmlAttrs
          }
        }, /*#__PURE__*/_react["default"].createElement(_reactFinalForm.FormSpy, {
          subscription: {
            submitFailed: true
          },
          onChange: _this2.onChangeSubmitFailed
        }), /*#__PURE__*/_react["default"].createElement(_Fields["default"], {
          formRender: formRender,
          formProps: formProps,
          fields: fields,
          disabled: disabled,
          components: _this2.props.components,
          opd: _this2.props.opd,
          opdSettings: _this2.props.opdSettings,
          getFileUrl: _this2.props.getFileUrl,
          postFileUrl: _this2.props.postFileUrl,
          apiUrl: _this2.props.apiUrl,
          allowFileExtensions: _this2.props.allowFileExtensions,
          serverErrors: _this2.props.serverErrors,
          htmlOpd: _this2.props.htmlOpd,
          htmlOpdStyles: _this2.props.htmlOpdStyles,
          getOpdValues: _this2.props.getOpdValues,
          renderOpdLabel: _this2.props.renderOpdLabel,
          setFormState: function setFormState(mutate) {
            return _this2.setState(mutate);
          },
          changeOptions: _this2.changeOptions,
          changeFieldValidation: _this2.changeFieldValidation,
          options: _this2.state.options,
          dictionaries: _this2.state.dictionaries,
          fieldsWithoutValidation: _this2.state.fieldsWithoutValidation,
          errors: _this2.state.errors,
          language: language,
          pdaLanguage: pdaLanguage,
          languageOrigin: _this2.props.languageOrigin,
          customValidation: customValidation,
          updateOpdValuesOn: updateOpdValuesOn,
          company: company
        }), /*#__PURE__*/_react["default"].createElement("div", null, !!captcha && captcha !== 'none' && /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
          key: language,
          name: "_captcha.value",
          component: _Captcha["default"],
          validate: function validate(value) {
            return value ? undefined : _i18n["default"].t('errors.captchaRequired');
          },
          language: language,
          options: captchaOptions,
          invalidCaptcha: (0, _errors.isError)('Invalid captcha', serverErrors)
        }), /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
          name: "personalDataAgreement",
          subscription: {
            value: true
          }
        }, function (_ref2) {
          var value = _ref2.input.value;
          return /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({
            className: styles.formBtn,
            type: "submit",
            disabled: opdSubmitDisabled && !value || submitted || disabled
          }, (0, _attrs.getAttrs)('submit', htmlAttrs)), submitted && /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null), /*#__PURE__*/_react["default"].createElement("span", {
            className: "button-text"
          }, t('send')));
        }))), (0, _errors.isError)('Access to applicant create restricted for current company license', serverErrors) && /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            marginTop: 15
          },
          className: styles.error,
          dangerouslySetInnerHTML: {
            __html: t('licenseError')
          }
        }));
      })));
    }
  }]);
  return Form;
}(_react.Component);

(0, _defineProperty2["default"])(Form, "defaultProps", {
  fields: [],
  dictionaryOptions: {},
  components: {},
  language: _translations.RU,
  pdaLanguage: _translations.RU,
  opdSubmitDisabled: true,
  excludeDictionary: {},
  renameDictionary: {},
  options: {},
  selectHeight: 34,
  selectLineHeight: 18,
  customValidation: {},
  updateOpdValuesOn: []
});

var _default = (0, _reactI18next.withTranslation)()(Form);

exports["default"] = _default;